import {
  FaBuilding,
  FaEnvelope,
  FaGlobe,
  FaIndustry,
  FaLocationDot,
  FaMapLocationDot,
  FaPhone,
  FaTags,
} from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { company } from '../../data/siteData'
import { openMailto, openTel } from '../../utils/contactLinks'

const corporateCards = [
  {
    label: 'Company Name',
    value: company.name,
    icon: FaBuilding,
    href: null,
  },
  {
    label: 'Business Type',
    value: 'Industrial metal trading & supply',
    icon: FaTags,
    href: null,
  },
  {
    label: 'Operational Base',
    value: 'Gujarat, India',
    icon: FaMapLocationDot,
    href: null,
  },
  {
    label: 'Factory Address',
    value: company.factoryAddress,
    icon: FaIndustry,
    href: null,
    isAddress: true,
  },
  {
    label: 'Factory Branch',
    value: company.branchAddress,
    icon: FaLocationDot,
    href: null,
    isAddress: true,
  },
  {
    label: 'Contact Number',
    value: `+91 ${company.phone}`,
    icon: FaPhone,
    href: company.tel,
  },
  {
    label: 'Email',
    value: company.email,
    icon: FaEnvelope,
    href: company.mailto,
    isEmail: true,
  },
  {
    label: 'Core Markets',
    value: 'India, GCC, Africa & global trade',
    icon: FaGlobe,
    href: null,
  },
]

function AboutCorporateInfo() {
  return (
    <AnimatedSection className="corp-info-section">
      <div className="container corp-container">
        <header className="corp-info-header">
          <span className="section-label section-label--gold">Corporate Information</span>
          <h2 className="corp-info-title">
            Company details for <span>professional</span> trade communication
          </h2>
          <p className="corp-info-lead">
            Essential information for partners, suppliers and buyers working with Torbit Metals.
          </p>
        </header>

        <div className="corp-info-grid">
          {corporateCards.map((card) => {
            const Icon = card.icon
            const body = (
              <>
                <span className="corp-info-card-icon" aria-hidden="true">
                  <Icon />
                </span>
                <span className="corp-info-card-label">{card.label}</span>
                <p
                  className={`corp-info-card-value${card.isAddress ? ' corp-info-card-value--address' : ''}`}
                >
                  {card.value}
                </p>
              </>
            )

            if (card.isEmail) {
              return (
                <a
                  className="corp-info-card corp-info-card--link"
                  key={card.label}
                  href={company.mailto}
                  onClick={(event) => openMailto(company.email, event)}
                >
                  {body}
                </a>
              )
            }

            return card.href ? (
              <a
                className="corp-info-card corp-info-card--link"
                key={card.label}
                href={card.href}
                onClick={
                  card.href === company.tel
                    ? (event) => openTel(company.phone, event)
                    : undefined
                }
              >
                {body}
              </a>
            ) : (
              <article className="corp-info-card" key={card.label}>
                {body}
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AboutCorporateInfo
